import PermissionsGuard from './PermissionsGuard';

export default PermissionsGuard;
